import { Route, Redirect } from "react-router-dom";
import { RouteProps } from "react-router";

import { useAppSelector } from "../store/hooks";

const RestrictedRoute = (routeProps: RouteProps) => {
  const loading = useAppSelector((state) => state.auth.loading);
  const authorized = useAppSelector((state) => state.auth.user.authorized);

  return authorized && !loading ? (
    <Route {...routeProps} />
  ) : (
    <Redirect to={{ pathname: "/login" }} />
  );
};

export default RestrictedRoute;
